// extracted by mini-css-extract-plugin
export var container = "_74-0";
export var containerTopRight = "_74-1";